import { createValidation } from '_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'
import * as Yup from 'yup'

export enum VinculoMode {
  Empresa = 'EMPRESA',
  Unidade = 'UNIDADE',
}

export const epecialidadeVinculoSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object({
    especialidades: Yup.array().min(1, v.requiredField('especialidade', 'array')),

    mode: Yup.mixed<VinculoMode>()
      .oneOf(Object.values(VinculoMode), 'Selecione o tipo de vínculo')
      .required('Selecione o tipo de vínculo'),

    empresas: Yup.array().when('mode', {
      is: VinculoMode.Empresa,
      then: (schema) => schema.min(1, v.requiredField('empresa', 'array')),
      otherwise: (schema) => schema.notRequired(),
    }),

    empresa: Yup.object().when('mode', {
      is: VinculoMode.Unidade,
      then: (schema) => schema.required(v.requiredField('empresa', 'select')),
      otherwise: (schema) => schema.notRequired(),
    }),

    unidades: Yup.array().when('mode', {
      is: VinculoMode.Unidade,
      then: (schema) => schema.min(1, v.requiredField('unidade', 'array')),
      otherwise: (schema) => schema.notRequired(),
    }),
  })
}
